import React, {FC} from 'react';
import { useTranslation } from 'react-i18next';
import styles from "./main.module.scss";
import {Link} from "react-router-dom";
import Button from "../../ui-kit/button/button";
import {handleScroll} from "../../../utils/scroll-helpers";


const Main: FC = () => {
    const { t } = useTranslation();

    const handleClick = () => {
        handleScroll('how-it-works')
    }

    return (
        <div id="main" className={styles.main}>
            <div className={styles.container}>
                <div className={styles.contentWrapper}>
                    <h1 className={styles.header}>{t('main.header')}</h1>
                    <h3 className={styles.description}>
                        {t('main.description')}
                    </h3>
                    <div className={styles.btnGroup}>
                        <Button className={styles.btn}  onClick={handleClick} type='outline'>{t('main.seeHowItWorks')}</Button>
                        <Link className={styles.link} to='search'>
                            <Button className={styles.btn}  type='primary'>{t('main.findInvestment')}</Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
